import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const billingDashboardSlice = createApi({
  reducerPath: 'billingDashboardSlice',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getBillingDashboardData: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/billing-engine/billing-summary/`,
        body: data,
        method: 'POST'
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBillingDashboardDataMutation } = billingDashboardSlice;
